import getWorkBook from '@/spreadsheets/getWorkBook'

export default () => getWorkBook()?.getActiveSheet()
